"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "capannori": {
    "3f72eccc": [{
      "hkey": "fffe6c12",
      "slug": "gragnano-lappato",
      "name": "Gragnano-Lappato",
      "primary": true,
      "skipSearch": false
    }],
    "gragnano": [{
      "hkey": "fffe6c12",
      "slug": "gragnano-lappato",
      "name": "Gragnano-Lappato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "adaa5a14": [{
      "hkey": "dd4baecc",
      "slug": "lammari-lunata",
      "name": "Lammari-Lunata",
      "primary": true,
      "skipSearch": false
    }],
    "lammari": [{
      "hkey": "dd4baecc",
      "slug": "lammari-lunata",
      "name": "Lammari-Lunata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "capannori"
    }],
    "0c992af1": [{
      "hkey": "dd4baecc",
      "slug": "lammari-lunata",
      "name": "Lammari-Lunata",
      "primary": true,
      "skipSearch": false
    }],
    "lunata": [{
      "hkey": "dd4baecc",
      "slug": "lammari-lunata",
      "name": "Lammari-Lunata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "capannori"
    }],
    "41c410e5": [{
      "hkey": "96bd71e2",
      "slug": "pieve-san-paolo-santa-margherita-toringo",
      "name": "Pieve San Paolo-Santa Margherita-Toringo",
      "primary": true,
      "skipSearch": false
    }],
    "pieve-san-paolo": [{
      "hkey": "96bd71e2",
      "slug": "pieve-san-paolo-santa-margherita-toringo",
      "name": "Pieve San Paolo-Santa Margherita-Toringo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6819bc68": [{
      "hkey": "654c5f29",
      "slug": "carraia-colognora-di-compito-parezzana",
      "name": "Carraia-Colognora di Compito-Parezzana",
      "primary": true,
      "skipSearch": false
    }],
    "carraia-parezzana": [{
      "hkey": "654c5f29",
      "slug": "carraia-colognora-di-compito-parezzana",
      "name": "Carraia-Colognora di Compito-Parezzana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f616b3e9": [{
      "hkey": "654c5f29",
      "slug": "carraia-colognora-di-compito-parezzana",
      "name": "Carraia-Colognora di Compito-Parezzana",
      "primary": true,
      "skipSearch": false
    }],
    "colognora-di-compito": [{
      "hkey": "654c5f29",
      "slug": "carraia-colognora-di-compito-parezzana",
      "name": "Carraia-Colognora di Compito-Parezzana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "capannori"
    }],
    "520a5c1d": [{
      "hkey": "e442cbaa",
      "slug": "paganico-tassignano",
      "name": "Paganico-Tassignano",
      "primary": true,
      "skipSearch": false
    }],
    "paganico": [{
      "hkey": "e442cbaa",
      "slug": "paganico-tassignano",
      "name": "Paganico-Tassignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "capannori"
    }],
    "a14ac171": [{
      "hkey": "96bd71e2",
      "slug": "pieve-san-paolo-santa-margherita-toringo",
      "name": "Pieve San Paolo-Santa Margherita-Toringo",
      "primary": true,
      "skipSearch": false
    }],
    "pieve-san-paolo-santa-margherita": [{
      "hkey": "96bd71e2",
      "slug": "pieve-san-paolo-santa-margherita-toringo",
      "name": "Pieve San Paolo-Santa Margherita-Toringo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ac5dda0f": [{
      "hkey": "e442cbaa",
      "slug": "paganico-tassignano",
      "name": "Paganico-Tassignano",
      "primary": true,
      "skipSearch": false
    }],
    "tassignano": [{
      "hkey": "e442cbaa",
      "slug": "paganico-tassignano",
      "name": "Paganico-Tassignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;